// extracted by mini-css-extract-plugin
module.exports = {"container":"Main_container__RziVg","content":"Main_content__CpvgR"};